import { RouteRecordRaw } from 'vue-router'
import { metaDataAuthGuard } from '@shared/guards/auth'
import { PermissionLevel, AuthScope } from '@shared/stores/auth'
import type { ExtractRouteNames } from '@shared/types/RouteNames'

// Analytics dashboard main component
const AnalyticsDashboard = () => import(/* webpackChunkName: "AnalyticsDashboard" */ '@analytics/views/AnalyticsDashboard.vue')

// User Dashboards
const AnalyticsOverviewUsers = () => import(/* webpackChunkName: "AnalyticsOverviewUsers" */ '@analytics/views/UsersDashboards/AnalyticsOverviewUsers.vue')
const AnalyticsOverviewUsersActivitiesCompleted = () => import(/* webpackChunkName: "AnalyticsOverviewUsersActivitiesCompleted" */ '@analytics/views/UsersDashboards/AnalyticsOverviewUsersActivitiesCompleted.vue')
const AnalyticsOverviewUsersVisits = () => import(/* webpackChunkName: "AnalyticsOverviewUsersVisits" */ '@analytics/views/UsersDashboards/AnalyticsOverviewUsersVisits.vue')

// Customer Dashboards
const AnalyticsOverviewCustomers = () => import(/* webpackChunkName: "AnalyticsOverviewCustomers" */ '@analytics/views/CustomersDashboards/AnalyticsOverviewCustomers.vue')
const AnalyticsOverviewCustomersLastVisited = () => import(/* webpackChunkName: "AnalyticsOverviewCustomersLastVisited" */ '@analytics/views/CustomersDashboards/AnalyticsOverviewCustomersLastVisited.vue')
const AnalyticsOverviewCustomersActivityReport = () => import(/* webpackChunkName: "AnalyticsOverviewCustomersActivityReport" */ '@analytics/views/CustomersDashboards/AnalyticsOverviewCustomersActivityReport.vue')
const AnalyticsOverviewCustomersNewCustomers = () => import(/* webpackChunkName: "AnalyticsOverviewCustomersNewCustomers" */ '@analytics/views/CustomersDashboards/AnalyticsOverviewCustomersNewCustomers.vue')

// RADAR Dashboards
const AnalyticsRadarYOYAnalysis = () => import(/* webpackChunkName: "AnalyticsRadarYOYAnalysis" */ '@analytics/views/RadarDashboards/AnalyticsRadarYOYAnalysis.vue')
const AnalyticsRadarTopCustomers = () => import(/* webpackChunkName: "AnalyticsRadarTopCustomers" */ '@analytics/views/RadarDashboards/AnalyticsRadarTopCustomers.vue')
const AnalyticsRadarSalesVsVisits = () => import(/* webpackChunkName: "AnalyticsRadarSalesVsVisits" */ '@analytics/views/RadarDashboards/AnalyticsRadarSalesVsVisits.vue')
const AnalyticsRadarRFMAnalysis = () => import(/* webpackChunkName: "AnalyticsRfmAnalysis" */ '@analytics/views/RadarDashboards/AnalyticsRadarRFMAnalysis.vue')

export const routes = {
  path: '/analytics-dashboard',
  name: 'AnalyticsDashboard',
  component: AnalyticsDashboard,
  beforeEnter: metaDataAuthGuard,
  meta: {
    requiredScopes: [{ level: PermissionLevel.Read, scope: AuthScope.AnalyticsDashboard }],
  },
  redirect: { name: 'AnalyticsOverviewUsers' },
  children: [
    // About my users
    {
      path: 'users/overview',
      name: 'AnalyticsOverviewUsers',
      beforeEnter: metaDataAuthGuard,
      component: AnalyticsOverviewUsers,
    },
    // // clickthroughs
    {
      path: 'users/activity-kpis',
      name: 'AnalyticsOverviewUsersActivitiesCompleted',
      beforeEnter: metaDataAuthGuard,
      component: AnalyticsOverviewUsersActivitiesCompleted,
    },
    {
      path: 'users/visits-report',
      name: 'AnalyticsOverviewUsersVisits',
      beforeEnter: metaDataAuthGuard,
      component: AnalyticsOverviewUsersVisits,
    },

    // About my customers
    {
      path: 'customers/overview',
      name: 'AnalyticsOverviewCustomers',
      beforeEnter: metaDataAuthGuard,
      component: AnalyticsOverviewCustomers,
    },
    // // clickthroughs
    {
      path: 'customers/activity-kpis',
      name: 'AnalyticsOverviewCustomersActivityReport',
      beforeEnter: metaDataAuthGuard,
      component: AnalyticsOverviewCustomersActivityReport,
    },
    {
      path: 'customers/last-visited',
      name: 'AnalyticsOverviewCustomersLastVisited',
      beforeEnter: metaDataAuthGuard,
      component: AnalyticsOverviewCustomersLastVisited,
    },
    {
      path: 'customers/new-customers',
      name: 'AnalyticsOverviewCustomersNewCustomers',
      beforeEnter: metaDataAuthGuard,
      component: AnalyticsOverviewCustomersNewCustomers,
    },

    // RADAR
    {
      path: 'radar/sales-vs-visits',
      name: 'AnalyticsRadarSalesVsVisits',
      beforeEnter: metaDataAuthGuard,
      component: AnalyticsRadarSalesVsVisits,
    },
    {
      path: 'radar/top-customers',
      name: 'AnalyticsRadarTopCustomers',
      beforeEnter: metaDataAuthGuard,
      component: AnalyticsRadarTopCustomers,
    },
    {
      path: 'radar/yoy-analysis',
      name: 'AnalyticsRadarYOYAnalysis',
      beforeEnter: metaDataAuthGuard,
      component: AnalyticsRadarYOYAnalysis,
    },
    {
      path: 'radar/rfm-analysis',
      name: 'AnalyticsRadarRFMAnalysis',
      beforeEnter: metaDataAuthGuard,
      component: AnalyticsRadarRFMAnalysis,
    },
  ] as const satisfies RouteRecordRaw[],
} as const satisfies RouteRecordRaw

export type DashboardRouteNames = ExtractRouteNames<typeof routes> | ExtractRouteNames<typeof routes.children[number]>

export default routes
